import React from 'react';
import OpportunityConfirmationPopup from './OpportunityConfirmationPopup';

/**
 * Opportunity Buttons, existing at bottom of create opportunity screen
 * @param text the text that will be displayed
 * @param className the className of the display
 * @param handleSubmit what happens when submit is pressed
 * @param orgID the id of the org that has this opportunity
 * @param isBackLink is this for backlink at the top of the screen?
 * @param leftButtonText text for the left button
 * @param rightButtonText text for the right button
 * @param headerText text for the header message
 * @constructor
 */
const OpportunityButton = ({
	text,
	className,
	handleSubmit,
	orgID,
	isBackLink,
	leftButtonText,
	rightButtonText,
	headerText,
}) => {
	const [show, setShow] = React.useState(false);

	/**
	 * Simple function that will hide the popup
	 */
	const handleClose = () => {
		setShow(!show);
	};

	return (
		<div>
			<div className={className} onClick={handleClose}>
				{isBackLink ? <i className="fas fa-chevron-left" /> : ''}
				<p>
					{text}
					{rightButtonText === 'Delete' ? (
						<i className="fas fa-trash" />
					) : (
						''
					)}
				</p>
			</div>
			{show && (
				<OpportunityConfirmationPopup
					handleSubmit={handleSubmit}
					handleClose={handleClose}
					orgID={orgID}
					leftButtonText={leftButtonText}
					rightButtonText={rightButtonText}
					headerText={headerText}
				/>
			)}
		</div>
	);
};

export default OpportunityButton;
